/**
 * Display a FontAwesome icon
 * @param {string} classes CSS classes
 * @param {string} style Direct style parameters
 * @param {string} title Title to set
 * @returns {string} HTML code
 */
function icon(classes, style, title) {
	let html = '<span class="' + classes + '"'

	if (typeof style !== 'undefined' && style !== '') {
		html += ' style="' + style + '"'
	}
	if (typeof title !== 'undefined' && title !== '') {
		html += ' title="' + title + '"'
	}
	html += '>&zwnj;</span>'

	return html
}

/*
 * Routing
 */

/**
 * Redirects browser to specified URL
 * @param {string} url URL to go to
 * @param {boolean} relative URL is within the site or not
 * @returns {void}
 */
function go(url, relative) {
	let base = ''

	if (typeof relative === 'undefined' || relative === true) {
		base = base_url
	}

	document.location.href = base + url
}

/**
 * Jumps back one page in browsing history
 * @returns {void}
 */
function go_back() {
	window.history.back()
}
